import { defineAsyncComponent } from 'vue';

const IconEpsilonSegmentAuto = defineAsyncComponent(() => import('./Auto.vue'));
const IconEpsilonSegmentBankingInvesting = defineAsyncComponent(() => import('./BankingInvesting.vue'));
const IconEpsilonSegmentBooksMagazines = defineAsyncComponent(() => import('./BooksMagazines.vue'));
const IconEpsilonSegmentCharitableDonors = defineAsyncComponent(() => import('./CharitableDonors.vue'));
const IconEpsilonSegmentCpg = defineAsyncComponent(() => import('./Cpg.vue'));
const IconEpsilonSegmentCreditDebitCards = defineAsyncComponent(() => import('./CreditDebitCards.vue'));
const IconEpsilonSegmentDemographics = defineAsyncComponent(() => import('./Demographics.vue'));
const IconEpsilonSegmentFinancials = defineAsyncComponent(() => import('./Financials.vue'));
const IconEpsilonSegmentFoodCooking = defineAsyncComponent(() => import('./FoodCooking.vue'));
const IconEpsilonSegmentFoodDrink = defineAsyncComponent(() => import('./FoodDrink.vue'));
const IconEpsilonSegmentHealthcare = defineAsyncComponent(() => import('./Healthcare.vue'));
const IconEpsilonSegmentHomeRealEstate = defineAsyncComponent(() => import('./HomeRealEstate.vue'));
const IconEpsilonSegmentHousehold = defineAsyncComponent(() => import('./Household.vue'));
const IconEpsilonSegmentInsurance = defineAsyncComponent(() => import('./Insurance.vue'));
const IconEpsilonSegmentLifestylesInterests = defineAsyncComponent(() => import('./LifestylesInterests.vue'));
const IconEpsilonSegmentPurchaseBehaviors = defineAsyncComponent(() => import('./PurchaseBehaviors.vue'));
const IconEpsilonSegmentPurchaseHistory = defineAsyncComponent(() => import('./PurchaseHistory.vue'));
const IconEpsilonSegmentRetail = defineAsyncComponent(() => import('./Retail.vue'));
const IconEpsilonSegmentSports = defineAsyncComponent(() => import('./Sports.vue'));
const IconEpsilonSegmentTechnologyConnectivity = defineAsyncComponent(() => import('./TechnologyConnectivity.vue'));
const IconEpsilonSegmentTravel = defineAsyncComponent(() => import('./Travel.vue'));
const IconEpsilonSegmentPolitical = defineAsyncComponent(() => import('./Political.vue'));
const IconEpsilonSegmentTransactional = defineAsyncComponent(() => import('./Transactional.vue'));

export {
  IconEpsilonSegmentAuto,
  IconEpsilonSegmentBankingInvesting,
  IconEpsilonSegmentBooksMagazines,
  IconEpsilonSegmentCharitableDonors,
  IconEpsilonSegmentCpg,
  IconEpsilonSegmentCreditDebitCards,
  IconEpsilonSegmentDemographics,
  IconEpsilonSegmentFinancials,
  IconEpsilonSegmentFoodCooking,
  IconEpsilonSegmentFoodDrink,
  IconEpsilonSegmentHealthcare,
  IconEpsilonSegmentHomeRealEstate,
  IconEpsilonSegmentHousehold,
  IconEpsilonSegmentInsurance,
  IconEpsilonSegmentLifestylesInterests,
  IconEpsilonSegmentPolitical,
  IconEpsilonSegmentPurchaseBehaviors,
  IconEpsilonSegmentPurchaseHistory,
  IconEpsilonSegmentRetail,
  IconEpsilonSegmentSports,
  IconEpsilonSegmentTechnologyConnectivity,
  IconEpsilonSegmentTransactional,
  IconEpsilonSegmentTravel,
};

export default {};
